import Ajv from 'ajv';
import * as GarageLaneScheme from './scheme.json';

const ajv = new Ajv();
export const GarageLaneValidator = ajv.compile(GarageLaneScheme);
